<template>
  <b-col
    lg="4"
    md="6"
    cols="12"
  >
    <b-card>
      <b-overlay
        :show="loadingOrderSummary"
        class="h-[12rem] md:h-[14rem]"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity="0.3"
      >
        <div class="bg-[#F8F8F8] border-2 rounded-xl p-1 mb-[10px]">
          <div class="d-flex justify-content-between text-xl mb-[10px]">
            <div class="d-flex my-auto font-semibold gap-2">
              <span class="k-bag-timer text-[#FBA63C] bg-[#FFF2E2] p-[5px] rounded" />
              Orderan Perlu Dikirim
            </div>
            <b-button
              variant="outline-secondary"
              class="rounded-lg p-0"
              size="sm"
              @click="$router.push({ path: 'data-order?tab=order-dibuat' })"
            >
              <feather-icon
                icon="ChevronRightIcon"
                size="25"
              />
            </b-button>
          </div>
          <div class="text-2xl font-semibold">
            {{ orderanPerluDikirim }}
          </div>
        </div>
        <div
          class="bg-[#F8F8F8] border-2 rounded-xl p-1"
        >
          <div class="d-flex justify-content-between text-xl mb-[10px]">
            <div class="d-flex my-auto font-semibold gap-2">
              <span class="k-danger text-[#E31A1A] bg-[#FFEDED] p-[5px] rounded" />
              Kendala Perlu Ditangani
            </div>
            <b-button
              variant="outline-secondary"
              class="rounded-lg p-0"
              size="sm"
              @click="$router.push({ path: '/ticketing' })"
            >
              <feather-icon
                icon="ChevronRightIcon"
                size="25"
              />
            </b-button>
          </div>
          <div class="text-2xl font-semibold">
            {{ needFollowUp }}
          </div>
        </div>
      </b-overlay>
    </b-card>
  </b-col>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      needFollowUp: sessionStorage.getItem('follow_up') || 0,
    }
  },
  computed: {
    ...mapState('dashboard', [
      'orderanPerluDikirim',
      'loadingOrderSummary',
    ]),
  },
}
</script>
